import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildRoomStreamVO } from "@youm-front/room/util/factory";
import {
  ROOM_LOCAL_STREAMS_FEATURE_KEY,
  RoomLocalStreamsState,
  roomLocalStreamsAdapter
} from "../reducers";
import { RoomStreamVO } from "@youm-front/room/domain";

const roomLocalStreamsState = createFeatureSelector<RoomLocalStreamsState>(
  ROOM_LOCAL_STREAMS_FEATURE_KEY
);

const { selectAll } = roomLocalStreamsAdapter.getSelectors();

export const roomLocalStreams = createSelector(
  roomLocalStreamsState,
  (state: RoomLocalStreamsState) =>
    selectAll(state).map((_) => buildRoomStreamVO(_))
);
export const roomLocalActiveStreams = createSelector(
  roomLocalStreams,
  (roomLocalStreams: RoomStreamVO[]) =>
    roomLocalStreams.filter((_) => _.value.streamIsActive)
);
